import styled from 'styled-components';
import { Text12Light, Text14Light } from '../Text/Text.styles';
import { theme, Transition } from '../../../styles/constants';

export const SingleValueText = styled.span`
  color: ${theme.colors.textColor};
`;

export const SingleValueTextLight = styled(SingleValueText)`
  opacity: 0.6;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled(Text12Light)``;

export const selectStyles = {
  control: baseStyles => ({
    ...baseStyles,
    background: `#fff`,
    minHeight: '3.4rem',
    borderRadius: '8px',
    fontSize: '1.4rem',
    boxShadow: 'none',
    outline: 'none',
    borderColor: '#F3F4F6',
    fontWeight: '400',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#F3F4F6',
    },
  }),
  placeholder: defaultStyles => {
    return {
      ...defaultStyles,
      color: '#0b3a5f',
      fontSize: '1.4rem',
      fontWeight: '300',
    };
  },
  input: defaultStyles => {
    return {
      ...defaultStyles,
      color: theme.colors.textColor,
    };
  },

  menu: baseStyles => ({
    ...baseStyles,
    background: `#fff`,
    borderRadius: '8px',
    border: '1px solid',
    boxShadow: 'none',
    overflow: 'auto',
    borderColor: '#F3F4F6',
  }),
  singleValue: baseStyles => ({
    ...baseStyles,
    color: theme.colors.textColor,
  }),
  option: baseStyles => ({
    ...baseStyles,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    fontSize: '1.4rem',
    gap: '1rem',
    color: theme.colors.textColor,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#BADAF760',
      transition: Transition.hover.on,
    },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: baseStyles => ({
    ...baseStyles,
    color: '#1672BA',
    height: '3.4rem',
  }),
};

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  position: relative;
  width: fit-content;
  margin-bottom: 0.4rem;
`;

export const TooltipContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #badaf7;
  background: #d8eaf9;
  padding: 1.2rem;
  position: absolute;
  width: 24rem;
  right: 0;
  bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  z-index: 1000;
`;

export const TooltipText = styled(Text14Light)`
  opacity: 0.8;
  line-height: 20px;
  letter-spacing: -0.408px;
`;

export const ErrorContainer = styled.div`
  color: ${theme.colors.error};
  font-size: 1rem;
  min-height: 1.3rem;
  letter-spacing: 0.5px;
  margin-left: 0.2rem;
  font-weight: 300;
`;

export const MenuButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 400;
  color: #1672ba;
  cursor: pointer;
  padding: 0.6rem 0;
  border-top: 1px solid #f3f4f6;
  text-decoration: underline;
`;
